__webpack_require__.p = "/wp-content/themes/ktb-v2/dist/";